module.exports = new __parcel__URL__("PostgresSQL.d1fbc52c.svg").toString();